// NoUserState.tsx
import { Box, Typography } from '@mui/material';
import React from 'react';
import { theme } from '@shared/theme';

const ReviewPlaceholder: React.FC = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(255, 255, 255, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}
  >
    <Box
      sx={{
        textAlign: 'center',
        padding: theme.spacing(4),
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(1.5),
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        maxWidth: 320,
        width: '80%',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          margin: 0,
          marginBottom: theme.spacing(2),
          fontSize: '1.5rem',
          color: theme.palette.text.primary,
        }}
      >
        Hang on a sec…
      </Typography>
      <Typography
        sx={{
          margin: 0,
          marginBottom: theme.spacing(3),
          color: theme.palette.text.secondary,
          fontSize: '1rem',
        }}
      >
        We're checking your account.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: theme.spacing(1),
          justifyContent: 'center',
        }}
      >
        {['0s', '0.2s', '0.4s'].map(delay => (
          <Box
            key={delay}
            component="span"
            sx={{
              'width': 10,
              'height': 10,
              'background': theme.palette.primary.main,
              'borderRadius': '50%',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 0.3 },
                '50%': { opacity: 1 },
              },
              'animation': 'pulse 1s ease-in-out infinite',
              'animationDelay': delay,
            }}
          />
        ))}
      </Box>
    </Box>
  </Box>
);

export default ReviewPlaceholder;
